import Modal from 'bootstrap/js/src/modal';
import { showToast } from '../helpers/toastr';

const escapeHtml = (str) => {
  const div = document.createElement('div');
  div.textContent = str || '';
  return div.innerHTML;
};

export const openPlaylistModal = (modalElement, triggerElement = null) => {
  if (!modalElement) return;

  const playerModalElement = document.getElementById('playerModal');
  const playerModal =
    playerModalElement && playerModalElement.classList.contains('show')
      ? Modal.getOrCreateInstance(playerModalElement)
      : null;

  if (playerModal) {
    // Bootstrap supports one active focus trap. Keep the player visible,
    // but hand focus management to the modal shown above it.
    // eslint-disable-next-line no-underscore-dangle
    playerModal._focustrap.deactivate();

    modalElement.addEventListener(
      'hidden.bs.modal',
      () => {
        window.requestAnimationFrame(() => {
          if (playerModalElement.classList.contains('show')) {
            // eslint-disable-next-line no-underscore-dangle
            playerModal._focustrap.activate();
          }
        });
      },
      { once: true },
    );
  }

  const playlistModalInstance = Modal.getOrCreateInstance(modalElement, { focus: false });
  // Focus traps cannot coexist while both modals remain visible.
  // eslint-disable-next-line no-underscore-dangle
  playlistModalInstance._focustrap.deactivate();
  if (triggerElement) {
    playlistModalInstance.show(triggerElement);
  } else {
    playlistModalInstance.show();
  }
};

export const addPlaylistCardToModal = (modal, playlist) => {
  const form = modal.querySelector('form.js-auto-submit-playlist-form');
  if (!form) return;

  const playlistId = String(playlist.id);
  if (form.querySelector(`.js-playlist-checkbox[value="${playlistId}"]`)) return;

  const existingInput = form.querySelector('input[name$="[playlist_ids][]"]');
  const paramKey = existingInput ? existingInput.name.split('[')[0] : 'chapter';
  const durationText = playlist.duration || '0h 0min';
  const lessonsCount = playlist.lessons_count || 0;

  const cardHtml = `
    <div class="c-playlist-card">
      <div class="c-playlist-card__icon"><i class="icon-new-bars-plus"></i></div>
      <div class="c-playlist-card__info">
        <div class="c-playlist-card__title">${escapeHtml(playlist.title)}</div>
        <div class="c-playlist-card__meta">${lessonsCount} Lessons • ${durationText}</div>
      </div>
      <div class="c-playlist-card__action">
        <input type="checkbox" value="${playlistId}" name="${paramKey}[playlist_ids][]" id="${paramKey}_playlist_ids_${playlistId}" class="js-playlist-checkbox" style="display: none !important;">
        <button class="btn btn-sm js-playlist-toggle-btn btn-outline-add" type="button">
          <span class="text-add">Add<i class="icon-new-plus"></i></span>
          <span class="text-added">Added<i class="icon-new-check"></i></span>
        </button>
      </div>
    </div>
  `;

  const firstCard = form.querySelector('.c-playlist-card');
  if (firstCard) {
    firstCard.insertAdjacentHTML('beforebegin', cardHtml);
  } else {
    form.insertAdjacentHTML('beforeend', cardHtml);
  }
};

export const updateAllPlaylistModals = (playlist) => {
  if (!playlist || !playlist.id) return;
  document.querySelectorAll('.c-playlist-modal').forEach((modal) => {
    addPlaylistCardToModal(modal, playlist);
  });
};

export const broadcastPlaylistCreated = (playlist) => {
  const payload = { playlist, timestamp: Date.now() };

  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel('gnomon_playlists');
      channel.postMessage({ type: 'PLAYLIST_CREATED', ...payload });
      channel.close();
    }
  } catch (e) {
    // ignore
  }

  try {
    localStorage.setItem('gnomon_last_created_playlist', JSON.stringify(payload));
  } catch (e) {
    // ignore
  }
};

const playlistModal = () => {
  $(() => {
    let pendingAttemptedModal = null;

    const reopenAttemptedModalIfAny = () => {
      const modalToOpen = pendingAttemptedModal;
      pendingAttemptedModal = null;

      if (modalToOpen) {
        window.requestAnimationFrame(() => {
          openPlaylistModal(modalToOpen);
        });
      }
    };

    const handlePlaylistCreated = (playlist) => {
      updateAllPlaylistModals(playlist);

      const attemptedModalId = sessionStorage.getItem('gnomon_attempted_playlist_modal_id');
      if (attemptedModalId) {
        const modalElement = document.getElementById(attemptedModalId);
        sessionStorage.removeItem('gnomon_attempted_playlist_modal_id');
        sessionStorage.removeItem('gnomon_awaiting_new_playlist');

        if (modalElement) {
          if (document.visibilityState === 'visible') {
            openPlaylistModal(modalElement);
          } else {
            pendingAttemptedModal = modalElement;
          }
        }
      }
    };

    // Check if on playlist show page after creation
    const newlyCreatedTracker = document.getElementById('js-newly-created-playlist');
    if (newlyCreatedTracker && newlyCreatedTracker.dataset.id) {
      broadcastPlaylistCreated({
        id: newlyCreatedTracker.dataset.id,
        title: newlyCreatedTracker.dataset.title || '',
        lessons_count: 0,
        duration: '0h 0min',
      });
    }

    // Cross-tab BroadcastChannel listener
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel('gnomon_playlists');
      channel.onmessage = (event) => {
        if (event.data && event.data.type === 'PLAYLIST_CREATED' && event.data.playlist) {
          handlePlaylistCreated(event.data.playlist);
        }
      };
    }

    // Cross-tab localStorage storage event listener
    window.addEventListener('storage', (event) => {
      if (event.key === 'gnomon_last_created_playlist' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue);
          if (data && data.playlist) {
            handlePlaylistCreated(data.playlist);
          }
        } catch (e) {
          // ignore
        }
      }
    });

    const handleTabRevisit = () => {
      if (document.visibilityState !== 'visible') return;

      if (pendingAttemptedModal) {
        reopenAttemptedModalIfAny();
        return;
      }

      if (sessionStorage.getItem('gnomon_awaiting_new_playlist')) {
        const raw = localStorage.getItem('gnomon_last_created_playlist');
        if (raw) {
          try {
            const data = JSON.parse(raw);
            if (
              data &&
              data.playlist &&
              data.timestamp &&
              Date.now() - data.timestamp < 30 * 60 * 1000
            ) {
              handlePlaylistCreated(data.playlist);
              return;
            }
          } catch (e) {
            // ignore
          }
        }

        fetch('/playlists.json', { headers: { Accept: 'application/json' } })
          .then((res) => (res.ok ? res.json() : null))
          .then((playlists) => {
            if (Array.isArray(playlists)) {
              playlists.forEach((p) => updateAllPlaylistModals(p));
              const attemptedModalId = sessionStorage.getItem('gnomon_attempted_playlist_modal_id');
              sessionStorage.removeItem('gnomon_awaiting_new_playlist');
              sessionStorage.removeItem('gnomon_attempted_playlist_modal_id');
              if (attemptedModalId) {
                const modalElement = document.getElementById(attemptedModalId);
                if (modalElement) {
                  openPlaylistModal(modalElement);
                }
              }
            }
          })
          .catch(() => {});
      }
    };

    window.addEventListener('focus', handleTabRevisit);
    document.addEventListener('visibilitychange', handleTabRevisit);

    $(document).on('show.bs.modal', '.c-playlist-modal', () => {
      const raw = localStorage.getItem('gnomon_last_created_playlist');
      if (raw) {
        try {
          const data = JSON.parse(raw);
          if (
            data &&
            data.playlist &&
            data.timestamp &&
            Date.now() - data.timestamp < 30 * 60 * 1000
          ) {
            updateAllPlaylistModals(data.playlist);
          }
        } catch (e) {
          // ignore
        }
      }
    });

    $('.js-player-playlist-modal').on('click', (event) => {
      event.preventDefault();
      const modalElement = document.querySelector(event.currentTarget.dataset.playlistModalTarget);
      openPlaylistModal(modalElement, event.currentTarget);
    });

    $('.js-playlist-modal-submit').on('click', (event) => {
      event.preventDefault();
      const { chapterId } = event.currentTarget.dataset;
      const { chapterIndex } = event.currentTarget.dataset;
      const modalId = $(`#playlist-modal-${chapterId}-${chapterIndex}`);
      const playlistCheckboxes = `js-playlist-checkboxes-${chapterId}-${chapterIndex}`;
      const playlistIds = $(`.${playlistCheckboxes}:checkbox:checked`)
        .map(function playlistId() {
          return $(this).val();
        })
        .get();
      if (playlistIds.length > 0) {
        const authToken = $('meta[name=csrf-token]').attr('content');
        const chapters = {
          chapter: {
            playlist_ids: playlistIds,
          },
          authenticity_token: authToken,
        };
        $.ajax({
          url: `/chapters/${chapterId}`,
          type: 'PUT',
          data: JSON.stringify(chapters),
          dataType: 'JSON',
          contentType: 'application/json',
          success() {
            showToast('success', 'Lesson added successfully');
          },
          error() {
            showToast('error', 'Oops! Something went wrong. Please try again later.');
          },
        });
        Modal.getOrCreateInstance(modalId[0]).hide();
        $('.modal-backdrop').remove();
      } else {
        showToast('error', 'Select at least one playlist to add a chapter');
      }
    });

    $(document).on('click', '.js-modal-create-playlist', (event) => {
      const rawModalId = event.currentTarget.dataset.modalId;
      const modalElement = rawModalId
        ? document.getElementById(rawModalId.replace(/^#/, ''))
        : event.currentTarget.closest('.modal');

      if (modalElement) {
        sessionStorage.setItem('gnomon_attempted_playlist_modal_id', modalElement.id);
        sessionStorage.setItem('gnomon_awaiting_new_playlist', 'true');
        Modal.getOrCreateInstance(modalElement).hide();
      }
    });
  });
};

export default playlistModal;
